/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams, useRouter } from "expo-router";

/* -----------------Child components--------------- */
import Box from "@memorang/ui/components/Box";
import ModalHeader from "@memorang/ui/components/ModalHeader";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";

const InfoModal = () => {
	const { title, body } = useLocalSearchParams<{
		title: string;
		body: string;
	}>();
	const router = useRouter();

	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader
							backIcon="arrow-left"
							headerTitle={title || ""}
							onBack={() => router.back()}
						/>
					),
				}}
			/>
			<Box flex={1}>
				<ScrollContainer>
					<Box padding={16}>
						<CustomMarkdownRenderer text={body} />
					</Box>
				</ScrollContainer>
			</Box>
		</>
	);
};

export default InfoModal;
